import Select from "react-select";
import { useEffect, useState } from "react";
import { FormGroup } from "reactstrap";
import { isEmpty } from "lodash";
import { Col } from "../Grid/Grid";

const FilterSelect = ({ title, items, value, onChange }) => {
  const [selected, setSelected] = useState({});

  useEffect(() => {
    setSelected(items?.find((obj) => value === obj.value));
  }, [value]);

  if (!items || !onChange) return null;

  return (
    <Col size="12" sm="6" md="4" lg="3" xxl="2" className="mt-3">
      <FormGroup>
        <label className="form-label" htmlFor="type">
          {title}
        </label>
        <div className="form-control-wrap">
          <Select
            openMenuOnFocus
            noOptionsMessage={() => <span>داده ای برای نمایش یافت نشد</span>}
            value={!isEmpty(selected) && selected}
            className="react-select-container"
            classNamePrefix="react-select"
            options={items}
            placeholder={title}
            onChange={(e) => onChange(e?.value)}
          />
        </div>
      </FormGroup>
    </Col>
  );
};

export default FilterSelect;
